import { render } from "./testsw.vue?vue&type=template&id=14799145"
import script from "./testsw.vue?vue&type=script&lang=js"
export * from "./testsw.vue?vue&type=script&lang=js"

import exportComponent from "E:\\01.Progetti\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__